export type DiscountMode = 'percentage' | 'amount' | 'final_price';

export interface DiscountInput {
  base: number;
  mode: DiscountMode;
  percentage?: number | null;
  amount?: number | null;
  finalPrice?: number | null;
  round?: boolean;
}

export interface DiscountResult {
  discountAmount: number;
  net: number;
}

const cents = (n: number) => Number(n.toFixed(2));

export function computeDiscount(input: DiscountInput): DiscountResult {
  const { base, percentage, amount, finalPrice, round } = input;
  let discountAmount: number;
  if (finalPrice != null && finalPrice > 0) {
    const target = round ? cents(finalPrice) : finalPrice;
    discountAmount = Math.max(0, base - target);
  } else {
    discountAmount = amount || (base * (percentage || 0)) / 100;
  }
  if (round) discountAmount = cents(discountAmount);
  let net = base - discountAmount;
  if (round) net = cents(net);
  return { discountAmount, net };
}
